
import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import LoginContainer from '../../Login/LoginContainer';

const UnauthenticatedAppView: React.FC =
  () =>
    (
      <Routes>
        <Route path='/login/callback' element={<LoginCallback />} />
        <Route path='*' element={<LoginContainer />} />
      </Routes>
    )

export default UnauthenticatedAppView
